import { Link } from "react-router-dom";

const articles = [
  {
    slug: "pandabuy-spreadsheet-ultimate-guide",
    title: "PandabuySpreadsheet Ultimate Guide",
    desc: "Master fashion spreadsheet shopping in 2026 with our complete guide covering all 14 categories, comparison strategies, and beginner tips.",
    badge: "In-Depth Guide",
    imageUrl: "https://readdy.ai/api/search-image?query=Minimalist%20fashion%20spreadsheet%20concept%20with%20a%20laptop%20displaying%20organized%20product%20data%20grid%20surrounded%20by%20curated%20fashion%20items%20like%20folded%20linen%20clothing%20leather%20accessories%20and%20neutral%20toned%20shoes%20on%20a%20warm%20wooden%20desk%20with%20soft%20morning%20light&width=800&height=500&seq=article-card-ultimate&orientation=landscape",
  },
  {
    slug: "pandabuy-spreadsheet-streetwear-guide",
    title: "Streetwear Essentials Guide",
    desc: "Curated urban fashion lists covering hoodies, sneakers, cargo pants, and accessories for building the ultimate streetwear wardrobe.",
    badge: "Streetwear",
    imageUrl: "https://readdy.ai/api/search-image?query=Modern%20streetwear%20fashion%20concept%20with%20curated%20clothing%20items%20arranged%20on%20a%20minimal%20wooden%20rack%20including%20oversized%20hoodies%20in%20neutral%20tones%20distressed%20denim%20cargo%20pants%20chunky%20sneakers%20and%20baseball%20caps%20with%20soft%20natural%20daylight&width=800&height=500&seq=article-card-streetwear&orientation=landscape",
  },
  {
    slug: "pandabuy-spreadsheet-sneaker-collectors",
    title: "Sneaker Collectors Handbook",
    desc: "Organize your sneaker collection with spreadsheet lists. Compare silhouettes, track colorways, and discover the best pairs across brands.",
    badge: "Sneakers",
    imageUrl: "https://readdy.ai/api/search-image?query=Stylish%20sneaker%20collection%20display%20featuring%20various%20trendy%20sneakers%20arranged%20on%20minimalist%20wooden%20shelves%20with%20neutral%20beige%20background%20soft%20diffused%20lighting%20creating%20gentle%20shadows%20editorial%20product%20photography&width=800&height=500&seq=article-card-sneakers&orientation=landscape",
  },
  {
    slug: "pandabuy-spreadsheet-budget-fashion",
    title: "Budget Shopping Strategies",
    desc: "Find quality fashion at affordable prices. Learn how spreadsheet comparison helps you maximize style while minimizing spending.",
    badge: "Budget",
    imageUrl: "https://readdy.ai/api/search-image?query=Thoughtfully%20curated%20affordable%20fashion%20concept%20with%20stylish%20yet%20budget%20friendly%20clothing%20items%20neatly%20arranged%20on%20a%20clean%20white%20surface%20including%20neutral%20toned%20basics%20denim%20pieces%20and%20simple%20accessories%20with%20soft%20morning%20light&width=800&height=500&seq=article-card-budget&orientation=landscape",
  },
  {
    slug: "pandabuy-spreadsheet-accessories-guide",
    title: "Essential Accessories Guide",
    desc: "Discover bags, belts, watches, jewelry, and perfumes organized in spreadsheet lists for effortless accessory coordination.",
    badge: "Accessories",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20arrangement%20of%20fashion%20accessories%20including%20leather%20bags%20minimalist%20watches%20delicate%20jewelry%20pieces%20stylish%20belts%20and%20designer%20sunglasses%20displayed%20on%20a%20light%20marble%20surface%20with%20soft%20natural%20window%20light&width=800&height=500&seq=article-card-accessories&orientation=landscape",
  },
  {
    slug: "pandabuy-spreadsheet-seasonal-wardrobe",
    title: "Seasonal Wardrobe Planning",
    desc: "Plan your fashion calendar across spring, summer, fall, and winter with organized spreadsheet lists for seamless seasonal transitions.",
    badge: "Seasonal",
    imageUrl: "https://readdy.ai/api/search-image?query=Four%20season%20fashion%20concept%20with%20clothing%20items%20representing%20spring%20summer%20autumn%20and%20winter%20arranged%20in%20four%20distinct%20quadrants%20on%20a%20clean%20surface%20featuring%20light%20floral%20pieces%20bright%20summer%20wear%20warm%20autumn%20layers%20and%20cozy%20winter%20knits&width=800&height=500&seq=article-card-seasonal&orientation=landscape",
  },
  {
    slug: "pandabuy-spreadsheet-luxury-alternatives",
    title: "Luxury Inspired Alternatives",
    desc: "Achieve premium style without premium prices. Find sophisticated fashion pieces that capture luxury aesthetics through smart spreadsheet curation.",
    badge: "Luxury",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20fashion%20display%20featuring%20sophisticated%20clothing%20and%20accessories%20with%20clean%20lines%20neutral%20color%20palette%20cream%20beige%20and%20taupe%20tones%20arranged%20on%20a%20marble%20surface%20with%20soft%20diffused%20lighting&width=800&height=500&seq=article-card-luxury&orientation=landscape",
  },
  {
    slug: "pandabuy-spreadsheet-outfit-building",
    title: "Outfit Building Masterclass",
    desc: "Create complete looks with confidence. Learn how to coordinate clothing, shoes, and accessories across categories using spreadsheet planning.",
    badge: "Style",
    imageUrl: "https://readdy.ai/api/search-image?query=Creative%20outfit%20building%20concept%20with%20multiple%20complete%20clothing%20combinations%20laid%20out%20on%20a%20wooden%20surface%20featuring%20coordinated%20tops%20bottoms%20shoes%20and%20accessories%20in%20complementary%20neutral%20tones%20with%20earthy%20accents%20soft%20natural%20light&width=800&height=500&seq=article-card-outfits&orientation=landscape",
  },
  {
    slug: "pandabuy-spreadsheet-trends-2026",
    title: "2026 Fashion Trends Report",
    desc: "Stay ahead of emerging fashion movements with real-time spreadsheet trend data covering streetwear, accessories, and luxury alternatives.",
    badge: "Trends",
    imageUrl: "https://readdy.ai/api/search-image?query=Forward%20looking%20fashion%20trends%20concept%20with%20contemporary%20clothing%20pieces%20in%20trending%20muted%20earth%20tones%20sage%20green%20warm%20terracotta%20and%20soft%20cream%20arranged%20artistically%20on%20a%20textured%20surface%20with%20gentle%20directional%20lighting&width=800&height=500&seq=article-card-trends&orientation=landscape",
  },
  {
    slug: "pandabuy-spreadsheet-comparison-guide",
    title: "Comparison Shopping Guide",
    desc: "Make smarter fashion decisions through side-by-side product comparison across all 14 PandabuySpreadsheet categories.",
    badge: "Comparison",
    imageUrl: "https://readdy.ai/api/search-image?query=Organized%20product%20comparison%20concept%20with%20multiple%20similar%20fashion%20items%20displayed%20side%20by%20side%20on%20a%20clean%20surface%20featuring%20sneakers%20accessories%20and%20clothing%20pieces%20arranged%20in%20neat%20rows%20for%20easy%20visual%20comparison%20soft%20even%20lighting&width=800&height=500&seq=article-card-compare&orientation=landscape",
  },
  {
    slug: "pandabuy-spreadsheet-capsule-wardrobe",
    title: "Capsule Wardrobe Blueprint",
    desc: "Build a minimalist fashion collection with 20-30 versatile pieces. Learn the spreadsheet method for intentional, timeless wardrobe curation.",
    badge: "Minimalist",
    imageUrl: "https://readdy.ai/api/search-image?query=Minimalist%20capsule%20wardrobe%20concept%20with%20a%20carefully%20curated%20selection%20of%20essential%20clothing%20pieces%20in%20neutral%20tones%20displayed%20on%20a%20wooden%20rack%20and%20folded%20neatly%20on%20shelves%20featuring%20versatile%20basics%20quality%20fabrics%20and%20timeless%20designs%20soft%20natural%20daylight&width=800&height=500&seq=article-card-capsule&orientation=landscape",
  },
];

export default function ArticlePreview() {
  return (
    <section className="w-full py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-4">
            SEO Resources
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            PandabuySpreadsheet Fashion Guides
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Explore our collection of in-depth fashion guides covering streetwear, sneakers, accessories, seasonal planning, and more — all powered by the PandabuySpreadsheet shopping system.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/${article.slug}`}
              className="group bg-background-50 rounded-xl border border-background-200/60 hover:border-primary-200/60 overflow-hidden transition-all duration-300 cursor-pointer"
            >
              <div className="w-full h-44 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <span className="inline-block px-2.5 py-0.5 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-2">
                  {article.badge}
                </span>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors duration-200 leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                  {article.desc}
                </p>
                <div className="mt-3 flex items-center gap-1 text-xs font-medium text-primary-600">
                  Read Article
                  <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center group-hover:translate-x-0.5 transition-transform duration-200"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}